export default __webpack_public_path__ + "images/2a4723879d15d9b37fb39779f0490c17-school.jpg";